import styled from 'foundations-theming/utils';
// @ts-expect-error module not typed
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import { getSubject
// @ts-expect-error module not typed
} from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledBig = styled.big.withConfig({
  displayName: "ForwardSubject__StyledBig",
  componentId: "sc-1jlaphc-0"
})(["align-self:flex-start;padding-block-start:", ";", ";"], ({
  theme
}) => theme.space[200], ({
  theme
}) => Object.assign({}, theme.typography['heading-50']));
export const ForwardSubject = ({
  message
}) => {
  // @bend-expect trellis-tokenized
  return /*#__PURE__*/_jsx(StyledBig, {
    children: getSubject(message)
  });
};
ForwardSubject.displayName = 'ForwardSubject';
ForwardSubject.propTypes = {
  message: RecordPropType('CommonMessage').isRequired
};